module.exports = __webpack_public_path__ + "assets/img/free.695196c5.png";